import {
  Car,
  Building2,
  MapPin,
  ShoppingCart,
  Utensils,
  Search,
  Wrench,
  HandHeart,
  Megaphone,
  Calendar,
  LayoutGrid,
} from 'lucide-react';
import { LayoutConfig } from '../../../components/layout/types';

export const dashboardLayoutConfig: LayoutConfig = {
  brandName: "Hubeau",
  brandSubtitle: "Connectivelle",
  sidebarWidth: 256, // 64 * 4 = 256px (w-64 equivalent)
  headerHeight: "4rem",
  showLocationDropdown: true,
  showSearchBar: true,
  searchPlaceholder: "Explore...",
  showViewSwitcher: true,
  menuSections: [
    {
      label: "Information",
      defaultOpen: true,
      items: [
        {
          icon: LayoutGrid,
          label: "Information Desk",
          path: "/information-desk",
          color: "text-indigo-600",
          sectionKey: "information-desk"
        },
        {
          icon: Megaphone,
          label: "Notices",
          path: "/notices",
          color: "text-purple-600",
          sectionKey: "notices"
        },
        {
          icon: Calendar,
          label: "Events",
          path: "/events",
          color: "text-blue-500",
          sectionKey: "events"
        },
      ]
    },
    {
      label: "Directory",
      defaultOpen: true,
      items: [
        {
          icon: Building2,
          label: "Tenants",
          path: "/tenants",
          color: "text-cyan-600",
          sectionKey: "tenants"
        },
        {
          icon: Utensils,
          label: "Food Court",
          path: "/food-court",
          color: "text-orange-600",
          sectionKey: "food-court"
        },
        {
          icon: MapPin,
          label: "Facilities",
          path: "/facilities",
          color: "text-teal-600",
          sectionKey: "facilities"
        },
        {
          icon: Wrench,
          label: "Services",
          path: "/services",
          color: "text-purple-500",
          sectionKey: "services"
        },
      ]
    },
    {
      label: "Community",
      defaultOpen: true,
      items: [
        {
          icon: ShoppingCart,
          label: "Buy & Sell",
          path: "/buy-sell",
          color: "text-green-600",
          sectionKey: "buy-sell"
        },
        {
          icon: HandHeart,
          label: "Request & Offer",
          path: "/request-offer",
          color: "text-indigo-600",
          sectionKey: "request-offer"
        },
        {
          icon: Search,
          label: "Lost & Found",
          path: "/lost-found",
          color: "text-blue-500",
          sectionKey: "lost-found"
        },
        {
          icon: Car,
          label: "Transportation",
          path: "/transportation",
          color: "text-sky-600",
          sectionKey: "transportation"
        },
      ]
    }
  ]
};



